import routes from './dirRoutes'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'history',
  base: '',
  routes,
})
//导航守卫
router.beforeEach((to, from, next) => {
  if(to.path.indexOf('/home') >= 0) {
    window.location.href = '/'
    return
  }
  next()
})
export default router
